import Mutation from './mutationTypes';
import { initialState } from './initialState';
import {
    apiSendPromptToAI,
    apiLoadChatHistory,
    apiDeleteChatHistory,
    apiGenerateChatTitle,
    apiRateChatMessage,
    apiUpdateChatTitle,
    apiLoadChatMessages,
    apiGetChatQueryCount,
    apiSearchChatHistory,
    apiEnsureChatDocIndexed,
    apiGetChatDocIndexStatus
} from "@/components/AIChat/api"

export default {
    setItem: ({ commit }, {field, value}) => {
        commit(Mutation.SET_ITEM, {field, value});
    },
    sendPromptToAI: async ({ commit, state, getters, dispatch }, message) => {
        try {
            let params = {
                docId: state.docId,
                itemId: state.itemId,
                chatId: state.chatId,
                resId: state.resId,
                pubId: state.pubId,
                versionId: state.versionId,
                message
            };
            commit(Mutation.ADD_TO_CHAT_MESSAGE, {role: 'user', messageId: '', content: message, citations: [] });
            commit(Mutation.SET_ITEM, {field: 'waitingReply', value: true});
            const reply =  await apiSendPromptToAI(params);
            if(reply) {
                let role = 'assistant';
                if(reply.aiMessage === 'subscription_chat_limit_exceeded') {
                    role = 'info';
                }
                if(reply.aiMessage === 'user_chat_limit_exceeded') {
                    role = 'info';
                }
                if(reply.aiMessage === 'openai_could_not_process_request') {
                    role = 'info';
                }
                dispatch('updateQuotaUsed'); //update quota used 
                commit(Mutation.ADD_TO_CHAT_MESSAGE, {role, messageId: reply.messageId, content: reply.aiMessage, citations: reply.citations });
                commit(Mutation.SET_ITEM, {field: 'waitingReply', value: false});
                if(reply.content !== 'subscription_chat_limit_exceeded' && reply.content !== 'user_chat_limit_exceeded' && reply.content !== 'openai_could_not_process_request') {
                    const stateChatId = state.chatId    
                    commit(Mutation.SET_ITEM, {field: 'chatId', value: reply.chatId});
                    //if(!chatObjExists) { //new chat
                    if( stateChatId == '') {//new chat
                        let tmpChatTitle = reply.aiMessage.substr(0, 30);
                        state.chatMessages.forEach(item => {
                            item.chat_id = reply.chatId;
                        });
                        let newChatItem = {
                            id: reply.chatId,
                            item_id: state.itemId,
                            doc_id: state.docId,
                            res_id: state.resId,
                            pub_id: state.pubId,
                            version_id: state.versionId,
                            created_at: reply.response_at,
                            udpated_at: reply.response_at,
                            title_tmp: tmpChatTitle,
                            title: null
                        };
                        commit(Mutation.LOAD_CHAT_HISTORY_ITEMS, {isNew: true, chatItems: [newChatItem]});
                    }
                    else {
                        let chatObjExists = getters.getChatHistoryItem(reply.chatId);
                        if(state.chatMessages.length > 3 && !chatObjExists.title) {
                            let chatTitle =  await apiGenerateChatTitle(reply.chatId);
                            commit(Mutation.UPDATE_CHAT_TITLE, { chatId: reply.chatId, title: chatTitle })
                        } 
                    }
                }
            } else {
                commit(Mutation.ADD_TO_CHAT_MESSAGE, {role: 'info', messageId: reply.messageId, content: 'openai_could_not_process_request', citations: [] });  
                commit(Mutation.SET_ITEM, {field: 'waitingReply', value: false});  
            }
            
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'waitingReply', value: false});
            console.log('api call failed for getting reply');
            console.log(error);
        }
    },
    loadChatHistory: async ({ commit, state }, filters) => {
        try {
            let chatHistory = state.chatHistory;
            if(chatHistory.length == 0) {
                filters = {...filters, offset: 0, limit: state.chatHistoryLimit};
                commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: true});
                chatHistory = await apiLoadChatHistory(filters);
                if(chatHistory.length > 0) {
                    commit(Mutation.LOAD_CHAT_HISTORY_ITEMS, {isNew: false, chatItems: chatHistory});
                    commit(Mutation.SET_ITEM,  {field: 'chatHistoryOffset', value: state.chatHistoryOffset + state.chatHistoryLimit});
                } else {
                    commit(Mutation.SET_ITEM,  {field: 'noChatHistroy', value: true});
                }
                
                chatHistory = state.chatHistory;
                commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: false});
            }
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: false});
            console.log('api call failed for chat history');
            console.log(error);
        }
    },
    loadMoreChatHistory: async ({ commit, state }) => {
        try {
            let filters = {
                docId: state.docId, 
                // userId: state.userId, 
                // subId: state.subId, 
                offset: state.chatHistoryOffset,
                limit: state.chatHistoryLimit
            };
            commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: true});
            let chatHistory = await apiLoadChatHistory(filters);
            if(chatHistory.length > 0) {
                commit(Mutation.LOAD_CHAT_HISTORY_ITEMS, {isNew: false, chatItems: chatHistory});
                const newOffset = state.chatHistoryOffset + state.chatHistoryLimit;
                commit(Mutation.SET_ITEM,  {field: 'chatHistoryOffset', value: newOffset });
            } else {
                commit(Mutation.SET_ITEM,  {field: 'noChatHistroy', value: true});
            }
            chatHistory = state.chatHistory;
            commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: false});
          
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'loadChatHistoryProcessing', value: false});
            console.log('api call failed for load ore chat history');
            console.log(error);
        }
    },
    initChatState: ({ commit }, excludeKeys) => {
        const newInitialState = JSON.parse(JSON.stringify(initialState));
        for (const key in newInitialState) {
            if(excludeKeys.includes(key)) {
                continue;
            }
            commit(Mutation.SET_ITEM, {field: key, value: newInitialState[key]});    
        }
    },
    initChat: async ({ commit, dispatch }, chatDetails) => {
        dispatch('stopIndexingPoll');
        let excludeKeys = [ 'chatHistory',  'faqs', 'quotaUsed', 'faqFetched'];
        dispatch('initChatState', excludeKeys);
        for (const key in chatDetails) {
            commit(Mutation.SET_ITEM, {field: key, value: chatDetails[key]});    
        }
        commit(Mutation.SET_ITEM, {field: 'showMainChatWindow', value: true});    
    },
    closeChat:  ({ commit, dispatch }) => {
        dispatch('stopIndexingPoll');
        commit(Mutation.SET_ITEM, {field: 'showMainChatWindow', value: false});
        commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: ''});
        commit(Mutation.SET_ITEM, {field: 'indexingError', value: ''});
    },
    deleteChatHistory: async ({ state, commit, dispatch }, chatId) => {
        try {
            commit(Mutation.SET_ITEM, {field: 'deleteChatItemLoading', value: true});
            const deletedSuccess =  await apiDeleteChatHistory(chatId);
            if(deletedSuccess) {
                if(chatId ==  state.chatId) {
                    dispatch('setUpNewChat');
                }
                commit(Mutation.REMOVE_CHAT_ITEM, chatId);
                commit(Mutation.SET_ITEM, {field: 'deleteChatItemLoading', value: false});
            } else {
                commit(Mutation.SET_ITEM, {field: 'deleteChatItemLoading', value: false});
                console.log('delete failed');
            }
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'deleteChatItemLoading', value: false});
            console.log('api call failed for deleting chat history');
            console.log(error);
        }  
    }, 
    updateChatTitle: async ({ commit }, {chatId, originalTitle, title}) => {
        try {
            commit(Mutation.UPDATE_CHAT_TITLE,  {chatId, title});
            const renameSuccess =  await apiUpdateChatTitle(chatId, title);
            if(!renameSuccess) {
                commit(Mutation.UPDATE_CHAT_TITLE,  {chatId, originalTitle});
                console.log('update chat title failed');
            } 
        } catch(error) {
            console.log('api call failed for update chat title');
            console.log(error);
        }  
    }, 
    rateChatMessage: async ({ commit, state }, { messageId, rating}) => {
        try {
            const rateSuccess =  await apiRateChatMessage(state.chatId, messageId, rating);
            if(rateSuccess) {
                commit(Mutation.SET_CHAT_MESSAGE_RATING, { messageId, rating });
            } else {
                console.log('chat message rating failed');
            }
        } catch(error) {
            console.log('api call failed for rating chat message');
            console.log(error);
        }  
    }, 
    setUpNewChat: async ({ commit }) => {
        commit(Mutation.SET_ITEM, {field: 'showSearchHistory', value: false});
        commit(Mutation.SET_ITEM, {field: 'showVersionOptions', value: false});
        commit(Mutation.SET_ITEM, {field: 'waitingReply', value: false});
        commit(Mutation.SET_ITEM, {field: 'chatMessages', value: []});
        commit(Mutation.SET_ITEM, {field: 'userMessage', value: ''});
        commit(Mutation.SET_ITEM, {field: 'loading', value: false});
        commit(Mutation.SET_ITEM, {field: 'itemId', value: ''}); 
        commit(Mutation.SET_ITEM, {field: 'chatId', value: ''});
        commit(Mutation.SET_ITEM, {field: 'resId', value: ''}); 
        commit(Mutation.SET_ITEM, {field: 'pubId', value: ''});
        commit(Mutation.SET_ITEM, {field: 'loadMoreMsgsProcessing', value: false});
        commit(Mutation.SET_ITEM, {field: 'loadMoreChatProcessing', value: false});
        commit(Mutation.SET_ITEM, {field: 'searchChatHistoryProcessing', value: false});
        commit(Mutation.SET_ITEM, {field: 'faq', value: ''});
        commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'version-selection'});
        commit(Mutation.SET_ITEM, {field: 'versionId', value: ''});
        commit(Mutation.SET_ITEM, {field: 'versionName', value: ''});
    },

    loadChatFromHistory: async ({ commit, dispatch, state }, chat) => {
        try {
            commit(Mutation.SET_ITEM, {field: 'loadChatMsgsProcessing', value: true});
            dispatch('setUpNewChat');
            commit(Mutation.SET_ITEM, {field: 'chatId', value: chat.id}); 
            commit(Mutation.SET_ITEM, {field: 'itemId', value: chat.item_id}); 
            commit(Mutation.SET_ITEM, {field: 'resId', value: chat.res_id}); 
            commit(Mutation.SET_ITEM, {field: 'pubId', value: chat.pub_id}); 
            commit(Mutation.SET_ITEM, {field: 'itemId', value: chat.item_id}); 
            commit(Mutation.SET_ITEM, {field: 'versionId', value: chat.version_id}); 
            commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'chat-messaging'}); 
            if (typeof chat.messages !== 'undefined' && 
                Array.isArray(chat.messages) && 
                chat.messages.length > 0) {
                commit(Mutation.LOAD_CHAT_MESSAGES, chat.messages);
            }
            else {
                let chatMessages = await apiLoadChatMessages(chat.id, 0, state.chatMessageLimit);
                if(chatMessages.length > 0) {
                    commit(Mutation.LOAD_CHAT_MESSAGES, chatMessages);
                    commit(Mutation.SET_ITEM, { field: 'chatMesageOffset', value: state.chatMessageLimit });
                } else {
                    commit(Mutation.LOAD_CHAT_MESSAGES, []);
                }
            }
            commit(Mutation.SET_ITEM, {field: 'loadChatMsgsProcessing', value: false});
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'loadChatMsgsProcessing', value: false});
            console.log('loading chat item from history failed');
            console.log(error);
        }  
    },
    loadMoreMessages: async ({ commit, state }, chatId) => {
        try {
            commit(Mutation.SET_ITEM, {field: 'loadMoreMsgsProcessing', value: true});
            let moreChatMessages = await apiLoadChatMessages(chatId,  state.chatMesageOffset, state.chatMessageLimit);
            if(moreChatMessages.length > 0) {
                commit(Mutation.LOAD_CHAT_MESSAGES, moreChatMessages);
                const newOffset = state.chatMesageOffset + state.chatMessageLimit ;
                commit(Mutation.SET_ITEM, { field: 'chatMesageOffset', value: newOffset});
                commit(Mutation.SET_ITEM, {field: 'loadMoreMsgsProcessing', value: false});
            } else {
                commit(Mutation.SET_ITEM, {field: 'loadMoreMsgsProcessing', value: false});
                console.log('loading more messages failed');
            }
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'loadMoreMsgsProcessing', value: false});
            console.log('api call failed while loading more messages');
            console.log(error);
        }  
    },
    updateQuotaUsed: async ({ commit }) => {
        try {
            let quotaUsed = await apiGetChatQueryCount();
            quotaUsed = isNaN(parseInt(quotaUsed, 10)) ? 0 : parseInt(quotaUsed, 10);
            commit(Mutation.SET_ITEM, {field: 'quotaUsed', value: quotaUsed});
        } catch(error) {
            console.log('api call to get quota used failed');
            console.log(error);
        }  
    },
    searchChatHistory: async ({ commit, getters }, searchTerm) => {
        try {
            commit(Mutation.SET_ITEM, {field: 'searchChatHistoryProcessing', value: true});
            let searchHistoryAbortController = getters.getItem('ajaxAbortController.apiSearchChatHistory');
            if(searchHistoryAbortController) {
                searchHistoryAbortController.abort(); //cancel previous ajax request
            }
            searchHistoryAbortController =  new AbortController();
            commit(Mutation.SET_ITEM, {field: 'ajaxAbortController.apiSearchChatHistory', value: searchHistoryAbortController});
            const searchResult = await apiSearchChatHistory(searchTerm, searchHistoryAbortController);
            if(!searchResult.canceled) {
                commit(Mutation.SET_ITEM, {field: 'searchResult', value:searchResult.data});
                commit(Mutation.SET_ITEM, {field: 'searchChatHistoryProcessing', value: false});
            }
        } catch(error) {
            commit(Mutation.SET_ITEM, {field: 'searchChatHistoryProcessing', value: false});
            console.log('api call failed for chat history');
            console.log(error);
        }
    },

    /**
     * Background ensure for product-page pre-index target.
     * Soft-fails — must not block opening the wizard.
     */
    ensurePreIndexOnOpen: async ({ state }, preIndexTarget) => {
        try {
            const target = preIndexTarget || state.preIndexTarget;
            if (!target || !target.itemId) {
                return;
            }

            // Always ask the server for the current state. The product-page
            // payload can be stale; the endpoint is idempotent and only queues
            // indexing when the latest main version is not indexed.
            await apiEnsureChatDocIndexed({
                itemId: target.itemId,
                docId: target.docId || state.docId,
                versionId: target.versionId || '',
                versionName: target.versionName || '',
                lang: target.lang || ''
            });
        } catch (error) {
            console.log('ensurePreIndexOnOpen soft-failed', error);
        }
    },

    /**
     * Open AIChat from feed deep-link with a specific version/language.
     * If already indexed → FAQ; else resume indexing-loading + poll.
     */
    openChatFromDeepLink: async ({ state, commit, dispatch }, selection) => {
        const versionId = selection && selection.versionId != null ? selection.versionId : state.versionId;
        const itemId = selection && selection.itemId != null ? selection.itemId : state.itemId;
        if (!versionId || !itemId) {
            return;
        }

        const version = state.versions && state.versions[versionId];
        let resId = selection && selection.resId != null ? selection.resId : state.resId;
        let pubId = selection && selection.pubId != null ? selection.pubId : state.pubId;
        let azureIndexed = 0;
        let versionName = state.versionName || '';

        if (version) {
            versionName = version.version || versionName;
            if (Array.isArray(version.lang)) {
                const langItem = version.lang.find(l => String(l.uid) === String(itemId));
                if (langItem) {
                    azureIndexed = parseInt(langItem.azureIndexed, 10) || 0;
                    if (!resId) {
                        resId = langItem.res_id || '';
                    }
                    if (!pubId) {
                        pubId = langItem.pub_id || '';
                    }
                }
            }
        }

        commit(Mutation.SET_ITEM, {field: 'versionId', value: versionId});
        commit(Mutation.SET_ITEM, {field: 'versionName', value: versionName});
        commit(Mutation.SET_ITEM, {field: 'itemId', value: itemId});
        commit(Mutation.SET_ITEM, {field: 'resId', value: resId});
        commit(Mutation.SET_ITEM, {field: 'pubId', value: pubId});

        if (azureIndexed === 1) {
            commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'faq-selection'});
            return;
        }

        // Reuse language-selection continue path (ensure + poll / FAQ when ready).
        await dispatch('continueAfterLanguageSelection');
    },

    /**
     * After language selection: if indexed → FAQ; else start indexing UI + poll.
     */
    continueAfterLanguageSelection: async ({ state, commit, dispatch }) => {
        const versionId = state.versionId;
        const itemId = state.itemId;
        const version = state.versions && state.versions[versionId];
        let azureIndexed = 0;
        let lang = '';
        if (version && Array.isArray(version.lang)) {
            const langItem = version.lang.find(l => String(l.uid) === String(itemId));
            azureIndexed = langItem ? parseInt(langItem.azureIndexed, 10) || 0 : 0;
            lang = langItem ? (langItem.lang || '') : '';
        }

        if (azureIndexed === 1) {
            commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'faq-selection'});
            return;
        }

        commit(Mutation.SET_ITEM, {field: 'indexingItemId', value: itemId});
        commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'indexing'});
        commit(Mutation.SET_ITEM, {field: 'indexingError', value: ''});
        commit(Mutation.SET_ITEM, {field: 'indexingPollAttempts', value: 0});
        commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'indexing-loading'});

        const ensured = await apiEnsureChatDocIndexed({
            itemId: itemId,
            docId: state.docId,
            versionId: versionId,
            versionName: state.versionName || (version && version.version) || '',
            resId: state.resId,
            pubId: state.pubId,
            lang: lang
        });

        if (ensured && ensured.status === 'ready') {
            dispatch('markSelectedLangIndexed', itemId);
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'ready'});
            commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'faq-selection'});
            return;
        }

        if (!ensured) {
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'error'});
            commit(Mutation.SET_ITEM, {field: 'indexingError', value: 'openai_index_start_failed'});
            return;
        }

        if (ensured.status === 'error') {
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'error'});
            commit(Mutation.SET_ITEM, {field: 'indexingError', value: 'openai_index_failed'});
            return;
        }

        dispatch('startIndexingPoll');
    },

    markSelectedLangIndexed: ({ state, commit }, itemId) => {
        const targetItemId = itemId || state.itemId;
        const versions = JSON.parse(JSON.stringify(state.versions || {}));
        const version = versions[state.versionId];
        if (version && Array.isArray(version.lang)) {
            version.lang = version.lang.map(l => {
                if (String(l.uid) === String(targetItemId)) {
                    return {...l, azureIndexed: 1};
                }
                return l;
            });
            versions[state.versionId] = version;
            commit(Mutation.SET_ITEM, {field: 'versions', value: versions});
        }
    },

    startIndexingPoll: ({ state, commit, dispatch }) => {
        dispatch('stopIndexingPoll');
        const generation = (state.indexingPollGeneration || 0) + 1;
        commit(Mutation.SET_ITEM, {field: 'indexingPollGeneration', value: generation});
        const abortController = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        commit(Mutation.SET_ITEM, {field: 'indexingAbortController', value: abortController});
        const timer = setInterval(() => {
            dispatch('pollIndexingStatusOnce');
        }, state.indexingPollIntervalMs || 5000);
        commit(Mutation.SET_ITEM, {field: 'indexingPollTimer', value: timer});
        dispatch('pollIndexingStatusOnce');
    },

    stopIndexingPoll: ({ state, commit }) => {
        if (state.indexingPollTimer) {
            clearInterval(state.indexingPollTimer);
            commit(Mutation.SET_ITEM, {field: 'indexingPollTimer', value: null});
        }
        if (state.indexingAbortController && typeof state.indexingAbortController.abort === 'function') {
            state.indexingAbortController.abort();
        }
        commit(Mutation.SET_ITEM, {field: 'indexingAbortController', value: null});
        commit(Mutation.SET_ITEM, {field: 'indexingPollInFlight', value: false});
    },

    pollIndexingStatusOnce: async ({ state, commit, dispatch }) => {
        if (state.wizardStep !== 'indexing-loading' || !state.indexingItemId) {
            return;
        }
        if (state.indexingPollInFlight) {
            return;
        }
        const polledItemId = state.indexingItemId;
        const generation = state.indexingPollGeneration;
        const attempts = (state.indexingPollAttempts || 0) + 1;
        commit(Mutation.SET_ITEM, {field: 'indexingPollAttempts', value: attempts});
        if (attempts > (state.indexingPollMaxAttempts || 180)) {
            dispatch('stopIndexingPoll');
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'error'});
            commit(Mutation.SET_ITEM, {field: 'indexingError', value: 'openai_index_timeout'});
            return;
        }

        commit(Mutation.SET_ITEM, {field: 'indexingPollInFlight', value: true});
        const statusPayload = await apiGetChatDocIndexStatus(
            polledItemId,
            state.docId,
            state.indexingAbortController
        );
        commit(Mutation.SET_ITEM, {field: 'indexingPollInFlight', value: false});
        if (!statusPayload || statusPayload.canceled) {
            return;
        }
        if (generation !== state.indexingPollGeneration) {
            return;
        }
        if (String(state.indexingItemId) !== String(polledItemId)) {
            return;
        }
        if (statusPayload.itemId && String(statusPayload.itemId) !== String(polledItemId)) {
            return;
        }
        if (statusPayload.status === 'error') {
            dispatch('stopIndexingPoll');
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'error'});
            commit(Mutation.SET_ITEM, {field: 'indexingError', value: 'openai_index_failed'});
            return;
        }
        if (statusPayload.status === 'ready') {
            dispatch('stopIndexingPoll');
            dispatch('markSelectedLangIndexed', polledItemId);
            commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'ready'});
            if (state.wizardStep === 'indexing-loading'
                && state.showMainChatWindow
                && String(state.indexingItemId) === String(polledItemId)
                && String(state.itemId) === String(polledItemId)) {
                commit(Mutation.SET_ITEM, {field: 'wizardStep', value: 'faq-selection'});
            }
        }
    },

    retryIndexing: async ({ dispatch, commit }) => {
        commit(Mutation.SET_ITEM, {field: 'indexingError', value: ''});
        commit(Mutation.SET_ITEM, {field: 'indexingStatus', value: 'indexing'});
        commit(Mutation.SET_ITEM, {field: 'indexingPollAttempts', value: 0});
        await dispatch('continueAfterLanguageSelection');
    },
}
